module.exports = __webpack_public_path__ + "static/media/luong-gio-ba-chieu-active.4f4329bc.svg";